import { Component, OnInit } from '@angular/core';
import { DocumentosService } from 'src/app/services/documentos/documentos.service';


@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css'],
  providers:[DocumentosService]
})
export class DocumentosComponent implements OnInit {

  public role="";
  constructor(private documentosService:DocumentosService) { 
    
    this.role=localStorage.getItem("role");
    
  }

  ngOnInit() {
  }

  generarDocumentos(){
    
      this.documentosService.recogerZip(this.role).subscribe((data:any)=>{
          //console.log(data);
          window.open(data);
      },error=>{
        console.log("error",error);
      });
  }
  


}
